function savedSearchDrawerController(
  _,
  $scope,
  $timeout,
  $translate,
  $uibModalInstance,
  distributorService,
  filtersService,
  savedSearchData,
  savedSearchService,
  schemaService,
  storyPitchingService,
  toastWrapperService,
  translateService,
  urlService
) {
  // This map should always be populated, as the UI Router states
  // in the app will resolve the data; nevertheless, the fallback
  // will prevent errors
  this.distMap = distributorService.distributors || new Map();

  if (savedSearchData.name) {
    $scope.updatingSearch = true;
  }

  $scope.dayDateString = $translate.instant('SET_DAY_BASED_DATE');
  $scope.relDateString = $translate.instant('SET_RELATIVE_DATE');

  $scope.alerts = [];

  $scope.dateOptions = [
    {
      name: 'yesterday',
      label: $translate.instant('YESTERDAY')
    },
    {
      name: 'today',
      label: $translate.instant('TODAY')
    },
    {
      name: 'now',
      label: $translate.instant('NOW')
    },
    {
      name: 'tomorrow',
      label: $translate.instant('TOMORROW')
    }
  ];

  $scope.labelTranslations = {
    startDate: 'START_DATE',
    endDate: 'END_DATE',
    sortOrder: 'SORT_BY',
    taskSort: 'TASK_SORT',
    direction: 'SEARCH_DIRECTION',
    contentType: 'CONTENT_TYPE',
    pitchesOnly: 'ONLY_PITCHED_STORIES_Q',
    pitchStatus: 'PITCH_STATUS',
    searchTerm: 'SEARCH_TERM',
    publishStatus: 'PUBLISH_STATUS',
    workflowStatus: 'WORKFLOW_STATUS',
    plan: 'PLAN',
    sections: 'SECTIONS',
    platforms: 'PLATFORMS',
    author: 'AUTHOR_NAME',
    authorID: 'AUTHOR',
    tags: 'TAGS',
    sourceType: 'DISTRIBUTOR.CATEGORY._LABEL_S',
    distributorId: 'DISTRIBUTOR.NAME',
    sponsored: 'SPONSORED_CONTENT',
    websites: 'MULTISITE.PRIMARY_WEBSITES',
    hierarchy: 'MULTISITE.VIEW_PLANS_FROM'
  };

  $scope.advancedSearchLabels = {
    author: 'AUTHOR (freelance)',
    authorID: 'AUTHOR',
    headline: 'HEADLINE',
    slug: 'SLUG',
    tags: 'TAGS'
  };

  $scope.sortLabels = {
    time: 'TIME',
    relevance: 'RELEVANCE'
  };

  $scope.taskSortLabels = {
    createdDate: 'TASK_CREATED',
    priority: 'PRIORITY',
    deadline: 'DEADLINE'
  };

  $scope.directionLabels = {
    asc: 'CHRONOLOGICAL',
    desc: 'REVERSE_CHRONOLOGICAL'
  };

  $scope.contentTypeLabels = {
    article: 'ARTICLE',
    video: 'VIDEO',
    gallery: 'GALLERY',
    graphic: 'GRAPHIC'
  };

  $scope.sponsoredLabels = {
    editorial: 'EDITORIAL',
    sponsored: 'SPONSORED'
  };

  $scope.sourceTypeLabels = {
    freelance: 'DISTRIBUTOR.CATEGORY.FREELANCE',
    handout: 'DISTRIBUTOR.CATEGORY.HANDOUT',
    other: 'DISTRIBUTOR.CATEGORY.OTHER',
    staff: 'DISTRIBUTOR.CATEGORY.STAFF',
    stock: 'DISTRIBUTOR.CATEGORY.STOCK',
    wires: 'DISTRIBUTOR.CATEGORY.WIRES'
  };

  $scope.cancel = () => {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.isArray = subject => Array.isArray(subject);

  $scope.toggleTbd = () => {
    $scope.filters.tbd.value = !$scope.filters.tbd.value;
  };

  $scope.removeFilter = (filter) => {
    delete $scope.filters[filter.name];
    delete $scope.savedSearch.params[filter.name];
  };

  $scope.clearFilter = (fil) => {
    const filter = fil;
    filter.value.special = null;
    filter.value.relative = null;
    filter.relativeNumber = null;
    filter.relativePeriod = null;
  };

  $scope.updateRelative = (fil) => {
    const filter = fil;
    filter.relativeNumber = filter.relativeNumber
      || (filter.relativePeriod ? 1 : null);
    filter.relativePeriod = filter.relativePeriod
      || (filter.relativeNumber ? 'hours' : null);

    if (filter.relativeNumber && filter.relativePeriod) {
      const sign = filter.relativeNumber < 0 ? '' : '+';
      filter.value.relative = sign + filter.relativeNumber + filter.relativePeriod;
    }
  };

  $scope.toggleDateSelectionMode = (fil) => {
    const filter = fil;
    filter.dateMode = filter.dateMode === 'special'
      || !filter.dateMode ? 'relative' : 'special';
  };

  $scope.getCurrentStartDate = () => {
    const { startDate } = $scope.filters;
    return startDate.value ? startDate.value[startDate.dateMode || 'special'] : null;
  };

  $scope.getCurrentEndDate = () => {
    const { endDate } = $scope.filters;
    return endDate.value ? endDate.value[endDate.dateMode || 'special'] : null;
  };

  $scope.save = () => {
    $scope.alerts = [];

    const { tbd, sortOrder, endDate, startDate } = $scope.filters;
    const endDateValue = endDate && endDate.value ? endDate.value[endDate.dateMode || 'special'] : null;
    const currentEndDate = urlService.getEpochTime(endDateValue);
    const currentStartDate = urlService.getEpochTime(startDate.value[startDate.dateMode || 'special']);

    $scope.saved_search_form.$endDateOrderError =
      !tbd.value
      && sortOrder.value !== 'relevance'
      && endDateValue
      && currentEndDate !== null
      && currentEndDate <= currentStartDate;

    $scope.saved_search_form.$setSubmitted();

    $scope.submitted = true;

    $timeout(() => {
      if ($scope.saved_search_form.$invalid || $scope.saved_search_form.$endDateOrderError) return;

      $scope.requestRunning = true;

      const save = $scope.savedSearch.id ? savedSearchService.update : savedSearchService.create;

      save(this.prepareSavedSearchData($scope.savedSearch))
        .then((data) => {
          $scope.requestRunning = false;
          $uibModalInstance.close(data);
          toastWrapperService.createToast($translate.instant('SUCCESSFULLY_SAVED_SEARCH'), 'success');
        }, ({ error }) => {
          $scope.requestRunning = false;
          $scope.alerts.push({
            type: 'danger',
            msg: error || $translate.instant('ERROR')
          });
        });
    });
  };

  this.prepareSavedSearchData = (savedSearch) => {
    const data = { ...savedSearch };

    _.each($scope.filters, (filter, filterName) => {
      data.params[filterName] = angular.copy(filter.value);
    });

    if ($scope.filters.author && $scope.filters.author.value) {
      data.params.author = Array.isArray(data.params.author) ?
        data.params.author[0] : data.params.author;
    }

    if ($scope.filters.authorID && $scope.filters.authorID.value) {
      data.params.authorID = [].concat(data.params.authorID);
    }

    if ($scope.filters.contentType && $scope.filters.contentType.value) {
      data.params.contentType = [].concat(data.params.contentType);
    }

    if ($scope.filters.limitToPitches) {
      data.params.pitchStatus = storyPitchingService.statuses;
    }

    if ($scope.filters.pitchStatus && $scope.filters.pitchStatus.value) {
      data.params.pitchStatus = [].concat(data.params.pitchStatus);
    }

    if ($scope.filters.platforms && $scope.filters.platforms.value) {
      data.params.platforms = [].concat($scope.filters.platforms.value);
    }

    if ($scope.filters.publishStatus && $scope.filters.publishStatus.value) {
      data.params.publishStatus = [].concat(data.params.publishStatus);
    }

    if ($scope.filters.sections && $scope.filters.sections.value) {
      data.params.sections = [].concat($scope.filters.sections.value);
    }

    if ($scope.filters.websites && $scope.filters.websites.value) {
      data.params.primaryWebsites = [].concat($scope.filters.websites.value);
      data.params.websites = null;
    }

    if ($scope.filters.slug) {
      data.params.slug = Array.isArray($scope.filters.slug.value) ?
        $scope.filters.slug.value[0] : $scope.filters.slug.value;
    }
    if ($scope.filters.headline) {
      data.params.headline = Array.isArray($scope.filters.headline.value) ?
        $scope.filters.headline.value[0] : $scope.filters.headline.value;
    }

    if ($scope.filters.headline) {
      data.params.headline = Array.isArray($scope.filters.headline.value) ?
        $scope.filters.headline.value[0] : $scope.filters.headline.value;
    }

    if ($scope.filters.sourceType) {
      data.params.sourceType = [].concat(data.params.sourceType);
    }

    if ($scope.filters.distributorId) {
      data.params.distributorId = [].concat(data.params.distributorId);

      data.params.distributorName = data.params.distributorId.reduce((acc, id) => {
        if (this.distMap.has(id)) {
          acc.push(this.distMap.get(id).name);
        }
        return acc;
      }, []);
    }

    if ($scope.filters.sponsored) {
      let contentParamValue;

      if (Array.isArray($scope.filters.sponsored.value)) {
        contentParamValue = $scope.filters.sponsored.value[0];
      } else {
        contentParamValue = $scope.filters.sponsored.value;
      }

      data.params.content = contentParamValue;
    }

    if ($scope.filters.tags && $scope.filters.tags.value) {
      data.params.tags = [].concat($scope.filters.tags.value);
    }

    if ($scope.filters.tbd.value) {
      delete data.params.startDate;
      delete data.params.endDate;
    } else {
      const { startDate } = data.params;
      let { endDate } = data.params;

      endDate = endDate || {};

      startDate[$scope.filters.startDate.dateMode === 'special' || !$scope.filters.startDate.dateMode ? 'relative' : 'special'] = null;
      endDate[$scope.filters.endDate.dateMode === 'special' || !$scope.filters.endDate.dateMode ? 'relative' : 'special'] = null;

      if (startDate.relative) {
        startDate.relative = urlService.relativeAlphaToNumeric(startDate.relative);
      }

      if (endDate.relative) {
        endDate.relative = urlService.relativeAlphaToNumeric(endDate.relative);
      }
    }

    if ($scope.filters.workflowStatus && $scope.filters.workflowStatus.value) {
      data.params.workflowStatus = [].concat(data.params.workflowStatus);
    }

    delete data.filters;

    return data;
  };

  this.prepareDateFilter = (fil) => {
    const filter = fil;

    if (filter.value && !_.isObject(filter.value)) {
      if (filter.value.toString().match(/[+-][\d\W]+[^\d\W]+/)) {
        filter.value = { relative: filter.value };
      } else if (_.isNumber(filter.value) || filter.value.match(/[+-][\d\W]+$/)) {
        filter.value = { relative: 0 };
      } else if (filter.value.match(/^[a-zA-Z]+$/)) {
        filter.value = { special: filter.value };
      } else {
        filter.value = { special: 'today', relative: null };
      }
    } else if (_.isObject(filter.value) && filter.value.relative) {
      filter.value = {
        relative: urlService.relativeNumericToAlpha(+filter.value.relative)
      };
    }

    filter.relativeNumber = filter.value.relative ? parseInt(filter.value.relative.match(/[\d\W]+/)[0], 10) : null;
    filter.relativePeriod = filter.value.relative ? filter.value.relative.match(/[^\d\W]+/)[0] : null;

    filter.dateMode = filter.relativeNumber && filter.relativePeriod ? 'relative' : 'special';
  };

  this.buildDisplayData = () => {
    const savedSearchFiltersCopy = { ...$scope.savedSearch.filters };

    /**
     * Remove savedSearch param so it doesn't show up in drawer as filter option
     * Although savedSearch param removed from app, keeping this here for backward compatability
     */
    if (savedSearchFiltersCopy.savedSearch) {
      delete savedSearchFiltersCopy.savedSearch;
    }

    $scope.filters = savedSearchFiltersCopy;

    if (!$scope.filters.tbd) {
      $scope.filters.tbd = _.merge({}, filtersService.availableFilters.tbd, { value: false });
    }

    if (!$scope.filters.startDate || !$scope.filters.startDate.value) {
      $scope.filters.startDate = _.merge({}, filtersService.availableFilters.startDate,
        {
          value: {
            special: !$scope.filters.tbd.value ? 'today' : null,
            relative: null
          }
        }
      );
    }

    if (!$scope.filters.endDate || !$scope.filters.endDate.value) {
      $scope.filters.endDate = _.merge({}, filtersService.availableFilters.endDate, {
        value: {
          special: null,
          relative: null
        }
      });
    }

    if (!$scope.filters.searchTerm) {
      const { searchTerm } = filtersService.availableFilters;
      $scope.filters.searchTerm = _.merge({}, searchTerm, { value: null });
    }

    $scope.filters.tbd.hideFromValueList = true;
    $scope.filters.startDate.hideFromValueList = true;
    $scope.filters.endDate.hideFromValueList = true;
    $scope.filters.searchTerm.hideFromValueList = true;

    _.each($scope.filters, (fil, filterName) => {
      const filter = fil;
      if ($scope.labelTranslations[filterName]) {
        filter.label = $translate.instant($scope.labelTranslations[filterName]);
      }
    });

    if (
      $scope.filters.startDate
      && $scope.filters.startDate.value
    ) {
      this.prepareDateFilter($scope.filters.startDate);
    }

    if (
      $scope.filters.endDate
      && $scope.filters.endDate.value
    ) {
      this.prepareDateFilter($scope.filters.endDate);
    }

    if ($scope.filters.author) {
      $scope.filters.author.displayValue = [].concat($scope.filters.author.value);
    }

    if ($scope.filters.authorID) {
      const authorIdFilterValue = $scope.filters.authorID.value;

      if (typeof authorIdFilterValue === 'string') {
        $scope.filters.authorID.displayValue = [authorIdFilterValue];
      } else if (Array.isArray(authorIdFilterValue)) {
        $scope.filters.authorID.displayValue = authorIdFilterValue;
      }
    }

    if ($scope.filters.workflowStatus && $scope.filters.workflowStatus.value) {
      $scope.filters.workflowStatus.displayValue = schemaService.getStatusString('workflow', $scope.filters.workflowStatus.value);
    }

    if ($scope.filters.publishStatus && $scope.filters.publishStatus.value) {
      $scope.filters.publishStatus.displayValue = schemaService.getStatusString('publish', $scope.filters.publishStatus.value);
    }

    if ($scope.filters.sortOrder && $scope.filters.sortOrder.value) {
      $scope.filters.sortOrder.displayValue = $scope.filters.sortOrder.value;
      const label = $scope.sortLabels[$scope.filters.sortOrder.displayValue];
      $scope.filters.sortOrder.displayValue = $translate.instant(label);
      $scope.filters.sortOrder.disableFilterRemoval = true;
    }

    if ($scope.filters.taskSort && $scope.filters.taskSort.value) {
      $scope.filters.taskSort.displayValue = $scope.filters.taskSort.value;
      const label = $scope.taskSortLabels[$scope.filters.taskSort.displayValue];
      $scope.filters.taskSort.displayValue = $translate.instant(label);
    }

    if ($scope.filters.direction && $scope.filters.direction.value) {
      $scope.filters.direction.displayValue = $scope.filters.direction.value;
      const label = $scope.directionLabels[$scope.filters.direction.displayValue];
      $scope.filters.direction.displayValue = $translate.instant(label);
    }

    if ($scope.filters.contentType && $scope.filters.contentType.value) {
      $scope.filters.contentType.value = [].concat($scope.filters.contentType.value);

      $scope.filters.contentType.displayValue = _.map([].concat($scope.filters.contentType.value), value => $translate.instant($scope.contentTypeLabels[value])).join(', ');
    }

    if ($scope.filters.limitToPitches && $scope.filters.limitToPitches.value) {
      delete $scope.filters.pitchStatus;
    } else if ($scope.filters.pitchStatus && $scope.filters.pitchStatus.value) {
      const { value } = $scope.filters.pitchStatus;
      $scope.filters.pitchStatus.displayValue = _.map([].concat(value), (val) => {
        translateService.key(val, 'PITCH_STATUS');
      }).join(', ');
    }

    if ($scope.filters.sponsored && $scope.filters.sponsored.value) {
      $scope.filters.sponsored.value = [].concat($scope.filters.sponsored.value);

      $scope.filters.sponsored.displayValue = $scope.filters.sponsored.value.map(value =>
        $translate.instant($scope.sponsoredLabels[value])).join(', ');
    }

    if ($scope.filters.sourceType && $scope.filters.sourceType.value) {
      $scope.filters.sourceType.value = [].concat($scope.filters.sourceType.value);

      $scope.filters.sourceType.displayValue = $scope.filters.sourceType.value.map(value =>
        $translate.instant($scope.sourceTypeLabels[value])).join(', ');
    }

    if ($scope.filters.distributorId && $scope.filters.distributorId.value) {
      $scope.filters.distributorId.value = [].concat($scope.filters.distributorId.value);
      $scope.filters.distributorId.displayValue = $scope.filters.distributorId.value
        .map(dist => ((this.distMap.get(dist) || {}).name) || dist)
        .join(', ');
    }

    if ($scope.filters.distributorName && $scope.filters.distributorName.value) {
      $scope.filters.distributorName.hideFromValueList = true;
    }

    _.each($scope.filters, (value, key) => {
      if (value.value === true) {
        $scope.filters[key].displayValue = $translate.instant('YES');
      }
    });

    _.each($scope.filters, (value, key) => {
      if (value.value !== false && !value.value) {
        $scope.filters[key].displayValue = filtersService.availableFilters[key].fallback;
      }
    });
  };

  $scope.savedSearch = angular.copy(savedSearchData);

  this.buildDisplayData();

  $scope.$watchGroup(['filters.startDate.relativeNumber', 'filters.startDate.relativePeriod'], (value) => {
    $scope.updateRelative($scope.filters.startDate, value);
  });

  $scope.$watchGroup(['filters.endDate.relativeNumber', 'filters.endDate.relativePeriod'], (value) => {
    $scope.updateRelative($scope.filters.endDate, value);
  });
}

const ctrlArr = [
  '_',
  '$scope',
  '$timeout',
  '$translate',
  '$uibModalInstance',
  'distributorService',
  'filtersService',
  'savedSearchData',
  'savedSearchService',
  'schemaService',
  'storyPitchingService',
  'toastWrapperService',
  'translateService',
  'urlService',
  savedSearchDrawerController
];

export default function (ngModule) {
  ngModule.controller('savedSearchDrawerController', ctrlArr);
}
